import type { OrderRow } from "../../../../types";

export type RankedRow = {
    label: string;
    count: number;
    value: number;
};

const DAY_MS = 24 * 60 * 60 * 1000;

export function parseBehaviorDate(value?: string) {
    if (!value) return null;

    const normalized = value.includes(" ") ? value.replace(" ", "T") : value;
    const date = new Date(normalized);

    return Number.isNaN(date.getTime()) ? null : date;
}

export function rankBy<T>(
    rows: T[],
    getKey: (row: T) => string,
    getValue: (row: T) => number,
    limit = 5,
) {
    const ranked = new Map<string, RankedRow>();

    for (const row of rows) {
        const label = getKey(row) || "Неуточнено";
        const current = ranked.get(label) ?? { label, count: 0, value: 0 };

        current.count += 1;
        current.value += getValue(row);
        ranked.set(label, current);
    }

    return [...ranked.values()]
        .filter((row) => row.label.trim() !== "")
        .sort((left, right) => right.value - left.value || right.count - left.count)
        .slice(0, limit);
}

export function averageOrderIntervalDays(orders: OrderRow[]) {
    const dates = orders
        .map((order) => parseBehaviorDate(order.createdAt))
        .filter((date): date is Date => date !== null)
        .sort((left, right) => left.getTime() - right.getTime());

    if (dates.length < 2) {
        return null;
    }

    const intervals = dates.slice(1).map((date, index) => {
        const previous = dates[index];

        return Math.max(0, Math.round((date.getTime() - previous.getTime()) / DAY_MS));
    });

    return intervals.reduce((sum, value) => sum + value, 0) / intervals.length;
}

export function daysSince(date: Date | null) {
    return date ? Math.max(0, Math.round((Date.now() - date.getTime()) / DAY_MS)) : null;
}
